import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 1rem;
`;

export const Content = styled.div`
  width: min(980px, 100%);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background-color: ${(props) => props.theme["gray-900"]};
  border-radius: 10px;
  padding: 1rem;
  color: ${(props) => props.theme.white};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  border-bottom: 1px solid ${(props) => props.theme["gray-500"]};
  padding-bottom: 1rem;

  select {
    border-radius: 8px;
    border: none;
    padding: 0.6rem;
    min-width: 260px;
  }
`;

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  input {
    border: none;
    border-radius: 8px;
    padding: 0.75rem;
  }
`;

export const Preview = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  background: linear-gradient(
    90deg,
    rgba(206, 112, 53, 1) 0%,
    rgba(255, 156, 0, 1) 35%,
    rgba(255, 177, 51, 1) 100%
  );
  border-radius: 16px;
  overflow: hidden;
  min-height: 300px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const PreviewText = styled.div`
  padding: 1rem;

  h2 {
    margin: 0 0 0.75rem 0;
  }

  p {
    margin: 0;
  }
`;

export const PreviewImage = styled.div`
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    min-height: 300px;
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
`;
